(function () {
  "use strict";

  HomeCatalogSidebarCtrl.$inject = ['$scope', '$rootScope', 'homeResource', 'catalogResource', 'trackingService', '$location', 'trainerPrivilege', 'mtypes'];
  angular
    .module('trainerWebApp.controllers')
    .controller('HomeCatalogSidebarCtrl', HomeCatalogSidebarCtrl);

  function HomeCatalogSidebarCtrl($scope, $rootScope, homeResource, catalogResource, trackingService, $location, trainerPrivilege, mtypes) {
    var viewState;

    var gaActions = trackingService.pages.trainerHome.actions;
    var gaPageName = trackingService.pages.trainerHome.name;
    var userRole = trainerPrivilege.roles();

    $scope.$watch('homeState.selectedItem', function () {
      if ($scope.homeState.selectedItem.type === "catalog") {
        setup($scope.homeState.selectedItem.id);
      }
    });

    function setup(catalogId, cb) {
      homeResource.getCatalogDetails(catalogId, function (result) {
        setState(result);
      }, function (err) {
      });
    }

    function setState(state) {
      viewState = state;
      viewState.canDeleteCatalog = userRole.canEditCourses;
      $scope.viewState = viewState;
      buildCatalogDetailsInfo();
    }

    $scope.gotoCatalog = function () {
      trackingService.trackEvent(gaPageName, gaActions.openCatalogAction);
      $location.path('/TMS/Catalog/' + $scope.homeState.selectedItem.id);
    };

    function buildCatalogDetailsInfo() {
      var coursesCount = _.filter(viewState.items, function (item) {
        return item.type == mtypes.courseType.online
      }).length;
      $scope.viewState.coursesCountLabel = "Courses: " + coursesCount;
      $scope.viewState.seriesCountLabel = "Series: " + (viewState.items.length - coursesCount);
      $scope.viewState.accessTypeLabel = "Access: " + viewState.accessType;
    }

    $scope.deleteCatalog = function () {
      if (!$scope.homeState.selectedItem.id) return;
      $rootScope.$broadcast('catalogDeletionRequestedEvent', $scope.homeState.selectedItem);
    };

    $scope.$on('catalogDeletionConfirmedEvent', function (event, catalogId, cb) {
      trackingService.trackEvent(gaPageName, gaActions.deleteCatalogAction);

      catalogResource.doDelete(catalogId, function () {
        $rootScope.$broadcast('catalogDeleted', catalogId);
        (cb || angular.noop)();
      }, function (err) {
        (cb || angular.noop)();
      });
    });

    $scope.catalogItemClick = function (item) {
      $scope.clearSearch();
      $scope.selectItemById(item.courseId);
    };
  }

})();
